import * as Comp from "../../../common/CommonComponents";
import * as common from "../../../common/common";
import http from "../../../common/http-common";
import CssClass from "../../../Styles/common.module.css";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useCookies } from "react-cookie";
import { Select } from "@mui/base";

//#region style
const customStyles = {
    container: (provided) => ({
      ...provided,
      width: '180px', // Set your desired width here
    }),
  };
//#endregion

const ReverseTicketStatus = (props) => {
    const [cookies] = useCookies([]);
    const [userId] = useState(cookies.USER_ID);
    const [dataToBeSelect, setDataToBeSelect] = useState({
        ACKNOWLEDGE: [
            {
                key : "OPEN",
                value : "OPEN",
                label : "OPEN",
            },            
        ],
    });
    const [reverseStatus, setReverseStatus] = useState({
        ACKNOWLEDGE: dataToBeSelect.ACKNOWLEDGE[0].key
    });
    const [inputError, setInputError] = useState([]);

    const message = (
        <>
            Confirm to reverse ticket status ?
            <table width={"80%"} style={{margin: "1rem 3rem"}} centered="true">
                <tbody>
                    <tr>
                        <td>Ticket Num</td>
                        <td> : </td>
                        <td>{<b>{props.viewData !== null && props.viewData.TICKET_NUM}</b>}</td>
                    </tr>
                    <tr>
                        <td>Current Ticket Status</td>
                        <td> : </td>
                        <td>{<b>{props.viewData !== null && props.viewData.TICKET_STATUS_TYPE_NAME}</b>}</td>
                    </tr>
                    <tr>
                        <td>New Ticket Status</td>
                        <td> : </td>
                        <td>
                            {props.viewData.TICKET_STATUS_TYPE_NAME === "ACKNOWLEDGE" && dataToBeSelect.ACKNOWLEDGE.length > 0
                                ? dataToBeSelect.ACKNOWLEDGE.length > 1
                                    ? <Comp.Select
                                        id="REVERSESTATUS"
                                        type="text"
                                        className="reverse-status-select"
                                        styles={customStyles}
                                        options={dataToBeSelect.ACKNOWLEDGE}
                                        closeMenuOnSelect={true}
                                        hideSelectedOptions={false}
                                        value={reverseStatus.key}
                                        onChange={(val) => selectionHandler(val, "ACKNOWLEDGE")}
                                    ></Comp.Select>
                                    : <b> {reverseStatus.ACKNOWLEDGE} </b>
                                : <></>                
                            }
                        </td>
                    </tr>
                </tbody>              
            </table>
            
            {/* <br />
            Ticket Num:
            {<b>{props.viewData !== null && props.viewData.TICKET_NUM}</b>}
            <br /> */}
           
        </>
    );

    const selectionHandler = (val, field) => {
        let functionName = "";
    
        try {
          functionName = selectionHandler.name;
          setInputError((prevState) => ({
            ...prevState,
            [field]: "",
          }));
          setReverseStatus((prevState) => ({
            ...prevState,
            [field]: val, 
          }));
        } catch (err) {
          common.c_LogWebError(props.page, functionName, err);
        }
      };

    const hideModal = () => {
        props.onHide();
    };

    const revStatusBtnOnClick = () => {
        updateReverseStatus(props.viewData);
    }

    const updateReverseStatus = (_data) => {

        let functionName = ""

        try {

            functionName = updateReverseStatus.name;

            props.onLoading(true, "Reversing ticket status, please wait...");

            var newStatus;

            var message = `Ticket status changed from [${_data.TICKET_STATUS_TYPE_NAME}] to [`

            if (_data.TICKET_STATUS_TYPE_NAME === "ACKNOWLEDGE") {

                newStatus = reverseStatus.ACKNOWLEDGE;

                message += reverseStatus.ACKNOWLEDGE;
            }
            
            message += `]`;

            const data = {
                TICKET_MST_ID: _data.TICKET_MST_ID,
                TICKET_NUM: _data.TICKET_NUM,
                TICKET_STATUS_TYPE_ID: _data.TICKET_STATUS_TYPE_ID,
                TICKET_STATUS_TYPE_NAME: _data.TICKET_STATUS_TYPE_NAME,
                NEW_TICKET_STATUS: newStatus,
                RESPONSE_DETAILS: message,
                UPDATE_ID: userId,
                UPDATE_DATETIME: _data.UPDATE_DATETIME,
            };
            
            http
                .post("api/Ticket/UpdateReverseTicketStatus", data, { timeout: common.DEFAULT_TIMEOUT })
                .then((response) => {
                    toast.success(`Ticket Status has successfully changed.`);
                    props.onReload();
                })
                .catch((err) => {
                    toast.error("Failed to reverse ticket status. Please try again.");
                    common.c_LogWebError(props.page, functionName, err);
                })
                .finally(() => {
                    props.onLoading(false);
                    hideModal();
                })

        } catch (err) {
            props.onLoading(false, "Loading...");
            toast.error("Failed to reverse ticket status. Please try again.");
            common.c_LogWebError(props.page, functionName, err);
        }
    }

    return (
        <>
            <Comp.ConfirmModal
                show={props.showHide}
                onHide={hideModal}
                onConfirm={revStatusBtnOnClick}
            >
                {message}
            </Comp.ConfirmModal>
        </>
    );
}

export default ReverseTicketStatus;